import { hasWaitingOrOngoingCall } from '@src/selectors/calls';
import { getUserCanReceiveCalls } from '@src/selectors/user';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

// eslint-disable-next-line no-shadow
export enum AgentCallPermissions {
  CAN_RECEIVE_CALLS = 'CAN_RECEIVE_CALLS',
  CAN_START_ANSWER_CALL = 'CAN_START_ANSWER_CALL',
}

const useCallAgentPermissions = () => {
  const [currentPermissions, setCurrentPermissions] = useState<
    Set<AgentCallPermissions>
  >(new Set([]));

  const canReceiveCalls = useSelector(getUserCanReceiveCalls);
  const canStartAnswerCall = !useSelector(hasWaitingOrOngoingCall);

  const addPermission = (permission: AgentCallPermissions) => {
    setCurrentPermissions(prev => {
      const newSet = new Set(prev);
      newSet.add(permission);
      return newSet;
    });
  };

  const removePermission = (permission: AgentCallPermissions) => {
    setCurrentPermissions(prev => {
      const newSet = new Set(prev);
      newSet.delete(permission);
      return newSet;
    });
  };

  useEffect(() => {
    if (canReceiveCalls) addPermission(AgentCallPermissions.CAN_RECEIVE_CALLS);
    else removePermission(AgentCallPermissions.CAN_RECEIVE_CALLS);

    if (canStartAnswerCall)
      addPermission(AgentCallPermissions.CAN_START_ANSWER_CALL);
    else removePermission(AgentCallPermissions.CAN_START_ANSWER_CALL);
  }, [canReceiveCalls, canStartAnswerCall]);

  const hasPermission = (permission: AgentCallPermissions) =>
    currentPermissions.has(permission);

  const hasAllPermissions = () =>
    Object.values(AgentCallPermissions).every(p => currentPermissions.has(p));

  return { hasPermission, hasAllPermissions };
};

export default useCallAgentPermissions;
